import { ReactComponent as Rafki } from "../assets/img/rafkisvg.svg";
import { ReactComponent as Rafki1 } from "../assets/img/assuredaccuracysvg.svg";
import { ReactComponent as Rafki2 } from "../assets/img/secureinsightsvg.svg";
import { String } from "./Strings";
export const slides = [
  {
    title: String.OnbordingStr.Title1,
    subtitle: String.OnbordingStr.SubTitle1,
    SvgComponent: Rafki,
  },
  {
    title: String.OnbordingStr.Title2,
    subtitle: String.OnbordingStr.SubTitle2,
    SvgComponent: Rafki1,
  },
  {
    title: "Secure Insights",
    subtitle: String.OnbordingStr.SubTitle3,
    SvgComponent: Rafki2,
  },
];
